import { Router, ActivatedRouteSnapshot } from '@angular/router';
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import { AlertService } from './alert.service';
import { ApiObjectData } from 'app/shared/model/apiObjectData';
import { ConfigService } from '../config.service';

@Injectable({
  providedIn: 'root'
})

export class BaseService {
  @BlockUI() blockUI: NgBlockUI;
  isRTL: boolean;
  dir: string;
  lang: string;
  apiUrl = this.configService.apiUrl;
  testUrl = this.configService.testUrl;

  headers = new HttpHeaders(
    {
      'X-Parse-Application-Id': 'tatawoey_parse',
      'X-Parse-REST-API-Key': 'REST_API_KEY',
      'Content-Type': 'application/json',
      'JWT-Access-Token': localStorage.getItem('token')
    });

  constructor(
    private http: HttpClient,
    private router: Router,
    private alertService: AlertService,
    private configService: ConfigService,
  ) { }

  postOut(url: string, model: any) {
    return this.http.post(this.apiUrl + url, model, { headers: this.headers });
  }


  get(id: any, controller: string): Observable<ApiObjectData> {
    return this.http.get<ApiObjectData>(this.testUrl + controller + '/' + id);
  }

  gets(controller: string): Observable<ApiObjectData> {
    return this.http.get<ApiObjectData>(this.testUrl + controller + '/');
  }

  save(controller: string, model: any) {
    return this.http.post(this.testUrl + controller + '/', model);
  }

  saveBatch(controller: string, model: any) {
    return this.http.post(this.testUrl + controller + '/', model);
  }

  remove(controller: string, id: number) {
    return this.http.delete(this.testUrl + controller + '/remove/' + id);
  }

  delete(controller: string, id: number) {
    return this.http.delete(this.testUrl + controller + '/delete/' + id);
  }

  getByUser(id: number, controller: string): Observable<ApiObjectData> {
    return this.http.get<ApiObjectData>(
      this.testUrl + controller + '/GetUserMenu/' + id
    );
  }

  post(controller: string, operation: string, model: any) {
    return this.http.post(this.testUrl + controller + '/' + operation, model);
  }

  postFile(controller: string, operation: string, fileToUpload: File) {
    const formData: FormData = new FormData();
    formData.append('fileKey', fileToUpload, fileToUpload.name);
    return this.http.post(this.testUrl + controller + '/' + operation, formData);
  }

  find(searchText: string, controller: string): Observable<ApiObjectData> {
    return this.http.get<ApiObjectData>(
      this.testUrl + controller + '/find/' + searchText
    );
  }

  observ(observ: any): Observable<ApiObjectData> {
    return observ.pipe(
      catchError(error => {
        this.alertService.error(
          'حدث خطأ غير متوقع يرجي إعادة المحاولة أو مراجعة مسؤول النظام'
        );
        console.log(error);
        this.router.navigate(['']);
        return of(null);
      })
    );
  }

  observnav(observ: any, commands: any[]): Observable<ApiObjectData> {
    return observ.pipe(
      catchError(error => {
        this.alertService.error(
          'حدث خطأ غير متوقع يرجي إعادة المحاولة أو مراجعة مسؤول النظام'
        );
        console.log(error);
        this.router.navigate(commands);
        return of(null);
      })
    );
  }

  resolveGet(
    service: any,
    route: ActivatedRouteSnapshot,
    url: string
  ): Observable<ApiObjectData> {
    //if (route.params.type === 'edit' || route.params.type === 'view') {
    return this.observnav(service.get(route.params.id), [
      url,
      route.params.id
    ]);
    // } else {
    //   return of(null);
    // }
  }

  resolveGetProfile(
    service: any,
    route: ActivatedRouteSnapshot,
    url: string
  ): Observable<ApiObjectData> {
    //if (route.params.type === 'edit' || route.params.type === 'view') {
    return this.observnav(service.getProfile(route.params.id), [
      url,
      route.params.id
    ]);
    // } else {
    //   return of(null);
    // }
  }

  resolveGetcustom(
    service: any,
    route: ActivatedRouteSnapshot,
    url: string
  ): Observable<ApiObjectData> {
    //if (route.params.type === 'edit' || route.params.type === 'view') {
    return this.observnav(service.GetJobActivities(route.params.id), [
      url,
      route.params.id
    ]);
    // } else {
    //   return of(null);
    // }
  }

  resolveGets(service: any): Observable<ApiObjectData> {
    return this.observ(service.gets());
  }

  resolveGetOther(service: any): Observable<ApiObjectData> {
    return this.observ(service);
  }

  resolveOperation(operation: any): Observable<ApiObjectData> {
    return this.observ(operation);
  }

  blockStart() {
    if (this.isRTL) {
      this.blockUI.start('تحميل البيانات');
    } else {
      this.blockUI.start('Loading Data');
    }
  }

  blockStartMsg(msg: string) {
    this.blockUI.start(msg);
  }

  blockStop() {
    this.blockUI.stop();
  }

}
